<template>
  <main>
    <OrganismForgetPassword/>
  </main>
</template>

<script>
export default {
  name: 'ForgetPassword',

  components: {
    OrganismForgetPassword: () => import('@/components/organisms/OrganismForgetPassword')
  }
}
</script>
